import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './StyledRelationship';

export function CorpEcosystemRelationshipCard(props) {
    const data = props.data || props.relationship || undefined;

    const company = data?.company;
    const { t } = useTranslation('ranking');
    // No year found?
    if (!data.year) data.year = 'N/D';

    const text = `${data.year} - ${data.programName}`;

    const propsCard = {
        as: data.onClick ? 'button' : undefined,
        onClick: data.onClick
    };

    const badges = [];
    if (data?.company && data?.company.status) {
        if (data?.company.status === 'confirmed') {
            badges.push(() => <div className="badge badge-success">{t('corporateConfirmed')}</div>);
        }
        // if (data?.company.status === 'pending') {
        //     badges.push(() => <div className="badge badge-warning">{t('corporatePending')}</div>);
        // }
        if (data?.company.status === 'rejected') {
            badges.push(() => <div className="badge badge-danger">{t('corporateRejected')}</div>);
        }
    }
    if (data?.ecosystem && data?.ecosystem.status) {
        if (data?.ecosystem.status === 'confirmed') {
            badges.push(() => <div className="badge badge-success">{t('ecosystemConfirmed')}</div>);
        }
        // if (data?.ecosystem.status === 'pending') {
        //     badges.push(() => <div className="badge badge-warning">{t('ecosystemPending')}</div>);
        // }
        if (data?.ecosystem.status === 'rejected') {
            badges.push(() => <div className="badge badge-danger">{t('ecosystemRejected')}</div>);
        }
    }
    if (
        data?.audited &&
        data?.status &&
        data?.status === 'confirmed' &&
        data?.displayAudit === true
    ) {
        if (data?.audited === 'confirmed') {
            const cn = 'badge badge-success';
            badges.push(() => <div className={cn}>{t('auditConfirmed')}</div>);
        }
        // if (data?.audited === 'pending') {
        //     const cn = 'badge badge-warning';
        //     badges.push(() => <div className={cn}>{t('auditPending')}</div>);
        // }
        if (data?.audited === 'rejected') {
            const cn = 'badge badge-danger';
            badges.push(() => <div className={cn}>{t('auditRejected')}</div>);
        }
    }
    // else if (data?.status && data?.status === 'confirmed' && !data?.displayAudit) {
    //     const cn = 'badge badge-warning';
    //     badges.push(() => <div className={cn}>{t('auditPending')}</div>);
    // }

    return (
        <Styled.RelationshipCard {...propsCard}>
            <Styled.CardImage img={encodeURI(company?.data?.logourl)} />

            <Styled.CardInfos>
                <span className="name">{company?.data?.name || company?.name}</span>
                <span className="text">{text}</span>

                {badges.map((Badge, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Badge key={`badge-${k}`} />
                ))}
            </Styled.CardInfos>
        </Styled.RelationshipCard>
    );
}
export default CorpEcosystemRelationshipCard;
